import React, { useState, useRef, useEffect } from "react"
import colors from "../../scripts/colors.ts"
import styled from "styled-components/macro"
import NavItem from "./NavItem"
import useArticleConditional from "../../hooks/useArticleConditional.ts"
import useGalleryConditional from "../../hooks/useGalleryConditional.ts"
import useCovidConditional from "../../hooks/useCovidConditional.ts"
import { useStaticQuery, graphql } from "gatsby"
import { FaBars, FaTimes } from "react-icons/fa"
import { BtnIconBox } from "../Button/Button"
import { useTransition, animated, config } from "react-spring"
import { useMediaQuery } from "react-responsive"
import useFacilityData from "../../hooks/useFacilityData.ts"

const NavStyles = styled.nav`
  position: relative;
  align-self: center;
  display: flex;
  z-index: 2000;
  @media screen and (min-width: 1024px) {
    display: flex;
    margin-bottom: 15px;
    align-self: flex-end;
  }
`

const NavUl = styled.ul`
  padding: 0;
  list-style-type: none;
  margin: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  position: absolute;
  top: 65px;
  right: 0;
  li.NavItem--subNav {
    button {
      display: none;
    }
  }
  @media screen and (min-width: 1024px) {
    top: 0;
    flex-direction: row;
    position: static;
    li.NavItem--subNav {
      button {
        display: flex;
      }
    }
  }
`

const NavToggle = styled.div`
  display: flex;
  @media screen and (min-width: 1024px) {
    display: none;
  }
`

const NavToggleBtn = styled(BtnIconBox)`
  border: 2px solid ${colors("grey")};
  background-color: ${colors("green", "lnk")};
`

const Nav = ({ headerType, currLocation }) => {
  const [open, setOpen] = useState(false)

  const hasArticles = useArticleConditional()

  const hasGalleryImages = useGalleryConditional()

  const hasCovidInfo = useCovidConditional()

  const facilityData = useFacilityData()

  const billPayUrl =
    facilityData.sanityFacility.facilityObj.facilityInfo.billPayUrl

  const isDesktop = useMediaQuery({ query: "(min-width: 1024px)" })

  const navArr = [
    {
      text: "Home",
      slug: "/",
      external: false,
    },
    {
      text: "About",
      slug: "#",
      external: false,
      active: true,
      subNavArr: [
        {
          active: hasGalleryImages ? true : false,
          text: "Gallery",
          slug: "/gallery",
          external: false,
        },
        {
          active: true,
          text: "Services",
          slug: "/#HomePage-serviceLinks",
          external: false,
        },
        {
          active: hasCovidInfo ? true : false,
          text: "Covid",
          slug: "/covid",
          external: false,
        },
        {
          active: hasArticles ? true : false,
          text: "News",
          slug: "/news",
          external: false,
        },
      ],
    },
    {
      active: true,
      text: "Careers",
      slug: "/careers",
      external: false,
    },
    {
      active: true,
      text: "Pay Bill",
      slug: billPayUrl,
      external: true,
    },
    {
      active: true,
      text: "Contact",
      slug: "/#HomePage-contact",
      external: false,
    },
  ]

  const navList = navArr.map(navItem => {
    const divRef = useRef(null)

    // console.log(currLocation)

    const vis = currLocation === "/" && navItem.text === "Home" ? false : true

    return navItem.active ? (
      <NavItem
        key={navItem.slug}
        slug={navItem.slug}
        subNavArr={navItem.subNavArr}
        external={navItem.external}
        headerType={headerType}
        vis={vis}
      >
        <div className="Nav-text" ref={divRef}>
          {navItem.text}
        </div>
      </NavItem>
    ) : null
  })

  const transitionOpacity = !isDesktop ? 0 : 1
  const transitionVert = isDesktop ? 0 : -100

  const transitions = useTransition(open, {
    from: { opacity: 0, y: -100 },
    enter: { opacity: 1, y: 0 },
    leave: { opacity: 0, y: -100 },
    reverse: open,
    config: {
      duration: 250,
    },
  })

  return (
    <NavStyles id="Nav--desktop" className="Site-nav" role="navigation">
      <NavToggle>
        <NavToggleBtn size="sm" as="button" onClick={() => setOpen(!open)}>
          {open ? <FaTimes /> : <FaBars />}
        </NavToggleBtn>
      </NavToggle>

      {isDesktop ? (
        <NavUl>{navList}</NavUl>
      ) : (
        transitions(
          (styles, item) =>
            item && (
              <animated.div style={styles}>
                <NavUl>{navList}</NavUl>
              </animated.div>
            )
        )
      )}
    </NavStyles>
  )
}

export default Nav
